import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getSizeFilterConfig } from '../filters/size';
import { getConditionsFilterConfig } from '../filters/condition';
import { BuilderSections } from '../../util/builder';

const mansurgavrielSizes: string[] = [
  'One Size - Bag',
  'S',
  'M',
  'L',
  'IT 35',
  'IT 35.5',
  'IT 36',
  'IT 36.5',
  'IT 37',
  'IT 37.5',
  'IT 38',
  'IT 38.5',
  'IT 39',
  'IT 39.5',
  'IT 40',
  'IT 40.5',
  'IT 41',
  'IT 41.5',
  'IT 42',
  'IT 42.5',
  'IT 43',
  'IT 44',
  'IT 45',
  'IT 46',
];

export const mansurgavrielShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({
      sizes: mansurgavrielSizes,
    }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.AboutPageInfoTabContent]: '71b0b9af4dbd4cf5a73dd9b850121bfb',
      [BuilderSections.FooterContent]: '0cc68e737081412ab06e95c5e352f5a7',
    },
  },
};
